module.exports = __webpack_public_path__ + "img/mail.2c0eda96.png";